import triggerCustomGaEvent from '../analytics/triggerCustomGaEvent'

export default function tripTeaseHotelSearch(startDateVal, endDateVal, adultsVal, childrenVal, numRoomsVal) {
	const tripTeaseSearchData = {
		"@context": "https://structured-data.triptease.io",
		"@type": "LodgingSearch",
		"checkinTime": startDateVal ? startDateVal.toString() : "",
		"checkoutTime": endDateVal ? endDateVal.toString() : "",
		"numAdults": adultsVal ? adultsVal.toString() : "",
		"numChildren": childrenVal ? childrenVal.toString() : "",
		"numRooms": numRoomsVal ? numRoomsVal.toString() : ""
	}
	triggerCustomGaEvent('triptease-search', tripTeaseSearchData)
}


// WEBPACK FOOTER //
// ./src/utilities/tripTease/tripTeaseHotelSearch.js